import { FC } from 'react'

import { Controller, useForm, useWatch } from 'react-hook-form'
import { string as yupString, object } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import SpotifyIcon from 'mdi-react/SpotifyIcon'
import styled from 'styled-components'

import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import { PrimaryInput } from 'src/Components/PrimaryInput'
import { setLoginTypeToInitialState } from 'src/Redux/auth-process/authTypeSlice'
import { getAuthEmail } from 'src/Redux/auth-process/authTypeSlice/selectors'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { initiateSpotifyAuth } from 'src/Utils/spotifyAuth'

import { SendLoginLink } from '../SendLoginLink'

const TextRed = styled.span`
  text-align: center;

  p {
    color: ${({ theme }) => theme.color.mediumRed};
    margin-bottom: 0;
  }
`

const TextBlack = styled.span`
  text-align: center;

  p {
    color: ${({ theme }) => theme.color.darkGrey};
    margin-bottom: 20px;
  }
`

const AccountOr = styled.div``

const Form = styled.form`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
`

const FullWidthButton = styled(PrimaryButton)`
  width: 100%;
`

interface FormState {
  email: string
}

export const LoginSpotify: FC = () => {
  const dispatch = useAppDispatch()
  const defaultEmail = useAppSelector(getAuthEmail)

  const { control } = useForm<FormState>({
    defaultValues: {
      email: defaultEmail,
    },
    mode: 'all',
    resolver: yupResolver(
      object({
        email: yupString().email().required(),
      }),
    ),
  })

  const email = useWatch({ control, name: 'email' })

  const handleLink = (): void => {
    dispatch(setLoginTypeToInitialState())
  }
  return (
    <>
      <Form>
        <Controller
          name='email'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <PrimaryInput
              {...field}
              placeholder='Email'
              error={error?.message}
              type='email'
              autoFocus
            />
          )}
        />
      </Form>
      <TextRed>Your account doesn't have a password</TextRed>
      <TextBlack>
        We can email you a quick login link so you can log in without typing a
        password.
      </TextBlack>
      <ButtonsContainer>
        <SendLoginLink email={email} />
        <AccountOr>Or</AccountOr>
        <FullWidthButton onClick={initiateSpotifyAuth}>
          <SpotifyIcon />
          Log in with Spotify
        </FullWidthButton>
        <AccountOr>Or</AccountOr>
        <FullWidthButton onClick={handleLink}>
          Log in to another account
        </FullWidthButton>
      </ButtonsContainer>
    </>
  )
}
